import React, { useState } from 'react';
import nhost from '../services/nhost';
import { GoogleIcon } from './GoogleIcon';

export default function LoginPage({ onLoginSuccess, onGuestLogin }) {
  const [isRegistering, setIsRegistering] = useState(false);
  const [forgotPasswordMode, setForgotPasswordMode] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setError(null);
    setLoading(true);
    try {
      if (isRegistering) {
        if (password !== confirmPassword) {
          setError("Mật khẩu không khớp.");
          return;
        }
        const { error } = await nhost.auth.signUp({ email, password });
        if (error) throw error;
        alert("Đăng ký thành công! Vui lòng kiểm tra email.");
      } else {
        const { error, session } = await nhost.auth.signIn({ email, password });
        if (error) throw error;
        onLoginSuccess(session); // chỉ email login mới dùng
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    setError(null);
    setLoading(true);
    try {
      await nhost.auth.signIn({ provider: 'google' });
      // Không cần gọi onLoginSuccess ở đây vì sẽ redirect
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const handleForgotPassword = async () => {
    setError(null);
    setLoading(true);
    try {
      if (!email) {
        setError("Vui lòng nhập email để đặt lại mật khẩu.");
        return;
      }
      const { error } = await nhost.auth.resetPassword({ email });
      if (error) throw error;
      alert("Email đặt lại mật khẩu đã được gửi.");
      setForgotPasswordMode(false);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={containerStyle}>
      <div style={titleStyle}>
        Đề Toán , Tiếng anh cơ bản, nâng cao <br />
        Dành cho học sinh cấp 2,cấp 3.
      </div>

      <div style={sloganStyle}>You can do it — never give up!</div>

      {!forgotPasswordMode ? (
        <>
          <h2 style={{ textAlign: 'center', marginBottom: 20 }}>🎓 Login</h2>

          <input placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} style={inputStyle} />
          <input placeholder="Mật khẩu" type="password" value={password} onChange={(e) => setPassword(e.target.value)} style={inputStyle} />

          {isRegistering && (
            <input placeholder="Xác nhận mật khẩu" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} style={inputStyle} />
          )}

          {error && <div style={{ color: 'red', marginBottom: 10, textAlign: 'center' }}>{error}</div>}

          <button onClick={handleSubmit} disabled={loading} style={btnStyle}>
            {isRegistering ? 'Đăng ký' : 'Đăng nhập'}
          </button>

          <button onClick={handleGoogleLogin} disabled={loading} style={{ ...btnStyle, backgroundColor: 'green', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
            <GoogleIcon /> Đăng nhập với Google
          </button>

          <button onClick={onGuestLogin} style={{ ...btnStyle, backgroundColor: '#6c757d' }}>
            👤 Không đăng nhập (Guest user)
          </button>

          <div style={{ marginTop: 20, textAlign: 'center' }}>
            <a onClick={() => setIsRegistering(!isRegistering)} style={linkStyle}>
              {isRegistering ? 'Đã có tài khoản? Đăng nhập' : 'Chưa có tài khoản? Đăng ký'}
            </a>
            <a onClick={() => { setForgotPasswordMode(true); setError(null); }} style={linkStyle}>Quên mật khẩu?</a>
          </div>
        </>
      ) : (
        <>
          <h2 style={{ textAlign: 'center', marginBottom: 20 }}>🔑 Đặt lại mật khẩu</h2>
          <input placeholder="Nhập email của bạn" value={email} onChange={(e) => setEmail(e.target.value)} style={inputStyle} />
          {error && <div style={{ color: 'red', marginBottom: 10, textAlign: 'center' }}>{error}</div>}
          <button onClick={handleForgotPassword} disabled={loading} style={btnStyle}>Gửi email đặt lại mật khẩu</button>
          <div style={{ marginTop: 20, textAlign: 'center' }}>
            <a onClick={() => { setForgotPasswordMode(false); setError(null); }} style={linkStyle}>Quay lại đăng nhập</a>
          </div>
        </>
      )}

      <div style={footerStyle}>
        <img src="https://oojbgyspwbwvnpxnokol.storage.ap-southeast-1.nhost.run/v1/files/acd23f6e-56b0-4bbc-bc3f-9752f400df9d" alt="Inspiration" style={{ maxWidth: '70%', borderRadius: 10 }} />
        <div style={{ marginTop: 12, fontSize: '12px', color: '#555' }}>
          Author: Lê Ngọc Hiếu <br />
          Email: <a href="mailto:hieuln@gmail.com">hieuln@gmail.com</a>
        </div>
        <p style={{ fontSize: 14, fontStyle: 'italic', color: '#999' }}>Tự học mọi lúc, mọi nơi.</p>
      </div>
    </div>
  );
}

const containerStyle = {
  maxWidth: 500,
  margin: '40px auto',
  fontFamily: 'sans-serif',
  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
  borderRadius: 10,
  padding: 30,
  backgroundColor: '#fff',
};

const inputStyle = {
  width: '100%',
  padding: 10,
  marginBottom: 12,
  fontSize: 16,
};

const btnStyle = {
  width: '100%',
  padding: 12,
  marginBottom: 12,
  fontSize: 16,
  backgroundColor: '#007bff',
  color: 'white',
  border: 'none',
  borderRadius: 5,
  cursor: 'pointer',
};

const titleStyle = {
  marginBottom: 8,
  fontWeight: 'bold',
  fontSize: '1rem',
  color: '#333',
  textAlign: 'center',
};

const sloganStyle = {
  marginBottom: 14,
  fontStyle: 'italic',
  color: '#bb1215ff',
  fontFamily: "'Comic Sans MS', 'Comic Neue', cursive",
  fontSize: '20px',
  textAlign: 'center',
};

const linkStyle = {
  color: '#007bff',
  cursor: 'pointer',
  marginRight: 20,
};

const footerStyle = {
  marginTop: 20,
  backgroundColor: '#f7f9fc',
  borderRadius: 10,
  padding: 10,
  textAlign: 'center',
  width: '100%',
};


